module.exports = __webpack_public_path__ + "./images/4841cfc205a6243192e69723f9b227fa.webp";